const ALLOWED_EXTENSIONS = new Set(["jpg", "jpeg", "png", "gif", "webp", "bmp", "doc", "docx", "xls", "xlsx", "pdf"]);
const ALLOWED_MIME_TYPES = new Set([
  "application/msword",
  "application/pdf",
  "application/vnd.ms-excel",
  "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
]);

export const EVALUATION_FILE_MAX_COUNT = 3;

export function isEvaluationFileAllowed(file) {
  if (!file) return false;
  const extension = String(file.name || "").split(".").pop().toLowerCase();
  return String(file.type || "").startsWith("image/")
    || ALLOWED_MIME_TYPES.has(file.type)
    || ALLOWED_EXTENSIONS.has(extension);
}
